/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import { reduce } from "lodash";

import { PeriodStat } from "~/features/dashboard/types";
import { TotalStatsItem } from "~/features/statistics/types";

const calculatePeriodStats: (data: TotalStatsItem[], from: string, to: string) => PeriodStat = (data, from, to) => {
  const dataArray = data
    .map((row) => row.details)
    .flat()
    .filter(
      (row) =>
        new Date(String(row.reportDate)).getTime() >= new Date(from).getTime() &&
        new Date(String(row.reportDate)).getTime() <= new Date(to).getTime(),
    );

  const netRevenue = reduce(dataArray, (acc, data) => acc + data.netRevenue, 0).toFixed(2);
  const grossRevenue = reduce(dataArray, (acc, data) => acc + Number(data.successfulThrustsAmount), 0).toFixed(2);
  const premiumJoins = reduce(dataArray, (acc, data) => acc + Number(data.premiumJoins), 0);

  return {
    netRevenue: Number(netRevenue),
    grossRevenue: Number(grossRevenue),
    premiumJoins,
  };
};

export default calculatePeriodStats;
